{
  "id": "talent-hub-wtu",
  "name": "Talent Hub - Work & Travel USA",
  "hidden": true,
  "sections": [
    {
      "id": "profilePhoto",
      "title": { "en": "Profile photo", "es": "Foto de perfil" },
      "type": "image",
      "fieldKey": "profileImage",
      "required": true
    },
    {
      "id": "identity",
      "title": { "en": "Personal Information", "es": "Información Personal" },
      "type": "form",
      "formGridClass": "form-grid form-grid--2",
      "fields": [
        {
          "id": "firstName",
          "label": { "en": "First Name", "es": "Nombre" },
          "inputType": "text",
          "required": true
        },
        {
          "id": "lastName",
          "label": { "en": "Last Name", "es": "Apellido" },
          "inputType": "text",
          "required": true
        }
      ]
    },
    {
      "id": "talentHub",
      "title": { "en": "Talent Hub", "es": "Talent Hub" },
      "type": "form",
      "formGridClass": "form-grid form-grid--stack",
      "fields": [
        {
          "id": "hub_why",
          "label": {
            "en": "Why do you want to participate in this program?",
            "es": "¿Por qué querés participar de este programa?"
          },
          "inputType": "textarea",
          "required": true
        },
        {
          "id": "hub_table",
          "label": {
            "en": "What can you bring to the table?",
            "es": "¿Qué podés aportar?"
          },
          "inputType": "textarea",
          "required": true
        },
        {
          "id": "hub_proud",
          "label": {
            "en": "What makes you feel proud of yourself?",
            "es": "¿Qué te hace sentir orgulloso/a de vos?"
          },
          "inputType": "textarea",
          "required": true
        },
        {
          "id": "hub_future",
          "label": {
            "en": "Where do you see yourself in the future?",
            "es": "¿Dónde te ves en el futuro?"
          },
          "inputType": "textarea",
          "required": true
        },
        {
          "id": "hub_additionl_info",
          "label": {
            "en": "More about yourself",
            "es": "Más sobre vos"
          },
          "inputType": "checkboxes",
          "required": true,
          "options": [
            {
              "value": "Athlete",
              "label": {
                "en": "I am an athlete. I participate in sports competitions.",
                "es": "Soy deportista y participo en competencias deportivas."
              }
            },
            {
              "value": "Practices Sports",
              "label": {
                "en": "I practice a sport frequently.",
                "es": "Practico un deporte con frecuencia."
              }
            },
            {
              "value": "Watching Sports Live (Venues)",
              "label": {
                "en": "I usually go to venues or stadiums to watch sports.",
                "es": "Suelo ir a estadios o sedes a ver deportes en vivo."
              }
            },
            {
              "value": "Team Sports",
              "label": {
                "en": "I have practiced a team sport for a long time.",
                "es": "Practiqué deporte de equipo durante mucho tiempo."
              }
            },
            {
              "value": "Martial Arts",
              "label": {
                "en": "I have practiced Karate, Tae Kwon Do, Judo, Jiu Jitsu or any other form Martial Arts for a long time.",
                "es": "Practiqué Karate, Taekwondo, Judo, Jiu Jitsu u otras artes marciales durante mucho tiempo."
              }
            },
            {
              "value": "Musical Arts",
              "label": {
                "en": "I frequently sing or play an instrument by myself or in a band.",
                "es": "Suelo cantar o tocar un instrumento solo o en una banda."
              }
            },
            {
              "value": "Plastic Arts",
              "label": {
                "en": "I frequently practice drawing, painting, sculpture, or other handicrafts.",
                "es": "Practico dibujo, pintura, escultura u otras manualidades con frecuencia."
              }
            },
            {
              "value": "Visual Arts",
              "label": {
                "en": "I am a filmmaker or participate in related activities.",
                "es": "Soy cineasta o participo en actividades audiovisuales."
              }
            },
            {
              "value": "Photographer",
              "label": {
                "en": "I am an amateur or professional photographer.",
                "es": "Soy fotógrafo/a aficionado o profesional."
              }
            },
            {
              "value": "Performer",
              "label": {
                "en": "I am an actor/actress, comedian, or similar.",
                "es": "Soy actor/actriz, comediante o similar."
              }
            },
            {
              "value": "Dancer",
              "label": {
                "en": "I am a dancer.",
                "es": "Soy bailarín/a."
              }
            },
            {
              "value": "Writer",
              "label": {
                "en": "I usually write poetry, or narratives, drama, essays, etc.",
                "es": "Escribo poesía, narrativa, teatro, ensayos, etc."
              }
            },
            {
              "value": "Event Planner",
              "label": {
                "en": "I enjoy planning and coordinating any kind of events.",
                "es": "Me gusta planificar y coordinar eventos de todo tipo."
              }
            },
            {
              "value": "Entrepreneur",
              "label": {
                "en": "I have started my own entrepreneurship.",
                "es": "Emprendí mi propio negocio."
              }
            },
            {
              "value": "Volunteering",
              "label": {
                "en": "I volunteer in a non-profit organization like TECHO, Fundación Sí, a scout group or any other charity.",
                "es": "Hago voluntariado en una ONG (TECHO, Fundación Sí, scouts u otra organización)."
              }
            },
            {
              "value": "Vegan/Vegetarian",
              "label": {
                "en": "I have strong vegetarian/vegan values.",
                "es": "Tengo valores vegetarianos/veganos muy fuertes."
              }
            },
            {
              "value": "Loves Animals",
              "label": {
                "en": "I deeply love animals. I have or had many of my own.",
                "es": "Amo los animales; tuve o tengo varios propios."
              }
            },
            {
              "value": "Environmentally Friendly",
              "label": {
                "en": "I care about our ecological footprint. I reduce, reuse, recycle, and repurpose every element I can to save the planet.",
                "es": "Me importa la huella ecológica; reduzco, reutilizo, reciclo y reaprovecho todo lo que puedo para cuidar el planeta."
              }
            },
            {
              "value": "Experienced Swimmer",
              "label": {
                "en": "I have been swimming for many years and I am very good at it.",
                "es": "Nado desde hace años y se me da muy bien."
              }
            },
            {
              "value": "Experienced Ski/SB",
              "label": {
                "en": "I have been skiing/snowboarding for many years and I am very good at it.",
                "es": "Esquío o hago snowboard desde hace años y se me da muy bien."
              }
            },
            {
              "value": "CPR/First Aid",
              "label": {
                "en": "I have a CPR/First Aid certification.",
                "es": "Tengo certificación de RCP / primeros auxilios."
              }
            },
            {
              "value": "Cooking/Baking",
              "label": {
                "en": "I find cooking or baking one of my passions, I do it regularly.",
                "es": "Cocinar u hornear es una de mis pasiones; lo hago seguido."
              }
            },
            {
              "value": "Booklover",
              "label": {
                "en": "I spend a lot of time reading novels or short stories.",
                "es": "Dedico mucho tiempo a leer novelas o cuentos."
              }
            },
            {
              "value": "Green Thumb",
              "label": {
                "en": "I have plants at home, which I take care of.",
                "es": "Tengo plantas en casa y las cuido."
              }
            },
            {
              "value": "Cars",
              "label": {
                "en": "I am very much into cars and races.",
                "es": "Me apasionan los autos y las carreras."
              }
            },
            {
              "value": "Carpentry",
              "label": {
                "en": "I love carpentry, I enjoy building things.",
                "es": "Me gusta la carpintería y construir cosas."
              }
            },
            {
              "value": "Foodie",
              "label": {
                "en": "I am always trying new food and restaurants everywhere I go.",
                "es": "Pruebo comida y restaurantes nuevos donde voy."
              }
            },
            {
              "value": "Culture Enthusiast",
              "label": {
                "en": "I spend a lot of time visiting museums, theaters, cultural centers, and events or tourist attractions.",
                "es": "Visito museos, teatros, centros culturales y atracciones turísticas con frecuencia."
              }
            }
          ]
        }
      ]
    },
    {
      "id": "experience",
      "title": { "en": "Work Experience", "es": "Experiencia Laboral" },
      "instructions": {
        "en": "Only add experience that may be relevant to the hospitality industry (e.g. restaurants, hotels, tourism, events). This section is optional.",
        "es": "Agregá solo experiencias que puedan ser relevantes para la industria de la hospitalidad (p. ej. restaurantes, hoteles, turismo, eventos). No es obligatorio."
      },
      "type": "list",
      "listRowGridClass": "form-grid form-grid--2",
      "itemFields": [
        {
          "id": "company",
          "label": { "en": "Company", "es": "Empresa" },
          "inputType": "text"
        },
        {
          "id": "role",
          "label": { "en": "Role", "es": "Rol" },
          "inputType": "text"
        },
        {
          "id": "period",
          "label": { "en": "Period", "es": "Período" },
          "inputType": "text"
        },
        {
          "id": "details",
          "label": { "en": "Details", "es": "Detalles" },
          "inputType": "textarea"
        }
      ]
    },
    {
      "id": "education",
      "title": { "en": "Education", "es": "Educación" },
      "instructions": {
        "en": "Only include your university or college (tertiary education).",
        "es": "Indicá solo la universidad o institución de educación superior."
      },
      "type": "list",
      "listRowGridClass": "form-grid form-grid--2",
      "itemFields": [
        {
          "id": "school",
          "label": { "en": "University", "es": "Universidad" },
          "inputType": "text",
          "required": true
        },
        {
          "id": "degree",
          "label": { "en": "Degree", "es": "Título / Carrera" },
          "inputType": "text",
          "required": true
        },
        {
          "id": "period",
          "label": { "en": "Start - End", "es": "Inicio - Fin" },
          "inputType": "text",
          "required": true
        }
      ]
    },
    {
      "id": "languages",
      "title": { "en": "Languages", "es": "Idiomas" },
      "instructions": {
        "en": "Do not list English or Spanish; include other languages only.",
        "es": "No incluyas inglés ni español; listá solo otros idiomas."
      },
      "type": "list",
      "listRowGridClass": "form-grid form-grid--pair",
      "itemFields": [
        {
          "id": "languageName",
          "label": { "en": "Language", "es": "Idioma" },
          "inputType": "text"
        },
        {
          "id": "languageLevel",
          "label": { "en": "Level", "es": "Nivel" },
          "inputType": "text"
        }
      ]
    }
  ]
}
